import React, { useEffect, useState } from "react";
import DashboardLayout from "../layouts/DashboardLayout";
import EsriFooter from "../components/EsriFooter";
import Checkbox from "../components/Checkbox";
import Textarea from "../components/Textarea";
import Fileinput from "../components/Fileinput";
import Button from "../components/Button";
import DashboardHeader from "../components/DashboardHeader";
import { NavLink } from "react-router-dom";
//import { useGet,usePost } from "../libs/service/api";
import { usePost, useGet } from "../libs/service/api";
import cookie from "../libs/cookie/client";

import { useHistory } from "react-router-dom";

const ContactUs = (props) => {
  const { toast, snackbar } = require("tailwind-toast");
  // const history = useHistory();
  const [message, setMessage] = useState("");
  const [isSending, setIsSending] = useState(false);
  const [isSucess, setIsSucess] = useState(false);
  const [queryFormSubmmited, setQueryFormSubmmited] = useState(false)
  const queryList = [
    {
      label: "Set up a <strong>call</strong>",
      value: "Set up a call",
      name: "howtohelp",
      checked: false,
    },
    {
      label: "Schedule a <strong>demo</strong>",
      value: "Schedule a demo",
      name: "howtohelp",
      checked: false,
    },
    {
      label: "Explore <strong>cost</strong> proposal",
      value: "Explore cost proposal",
      name: "howtohelp",
      checked: false,
    },
    {
      label: "Send me some <strong>case Studies</strong>",
      value: "Send me some case Studies",
      name: "howtohelp",
      checked: false,
    },
    {
      label: "Understand <strong>implementation</strong>",
      value: "Understand implementation",
      name: "howtohelp",
      checked: false,
    },
  ];

  let tempqueryarraylist;
  if (localStorage.getItem("tempqueryarray") === null) {
      tempqueryarraylist = [];
  } else {
      tempqueryarraylist = JSON.parse(localStorage.getItem("tempqueryarray"))
  }

  const [tempqueryarray, setTempqueryarray] = useState(tempqueryarraylist)

  const [queryListJson, setQueryListJson] = useState(queryList);
  const onCheckBoxClick = (item, index, array) => {
    if (item.checked == undefined) item.checked = true;
    else item.checked = !item.checked;
    setQueryListJson([...array]);
  };
  const handleChange = (e) => {
    setMessage(e.target.value);
  };
  const handleBlur = (e) => {
    setMessage(e.target.value);
  };
  const SubmitQuery = () => {
    var strMessage = "";
    console.log(queryListJson);
    for (var i = 0; i < queryListJson.length; i++) {
      if (queryListJson[i].checked == true) {
        strMessage = strMessage + queryListJson[i].value + ",";
      }
    }

    if (strMessage.length > 0 && message.length > 0) {
      SaveQuery(strMessage);
    } else {
      SaveQuery(strMessage);
      // toast()
      //   .danger("", "Select Query")
      //   .with({
      //     shape: "square",
      //     duration: 2000,
      //     speed: 200,
      //     positionX: "end",
      //     positionY: "top",
      //     color: "text-white bg-secondary border-secondary-dark border rounded-lg",
      //     fontColor: "white",
      //     fontTone: 0,
      //   })
      //   .show();
    }
  };
  const ClearValues = () => {
    document.querySelector("#message").value = "";
    setQueryListJson([...queryList]);
  };
  const SaveQuery = (strMessage) => {
    const sendqueryarray = queryListJson.filter(i => i.checked == true)
    setIsSending(true)
    usePost("/commonapi/userquery", [
      {
        key: "options",
        value: strMessage,
      },
      {
        key: "message",
        value: message,
      },
    ]).then((res) => {
      setIsSucess(true)
      setTempqueryarray([...sendqueryarray])
      localStorage.setItem("tempqueryarray", JSON.stringify(tempqueryarray))
      setIsSending(false)
      SendEmail(res.Data.Table[0].ID)
      setTimeout(
        function () {
          setIsSucess(false)
        }
          .bind(this),
        3000
      );
      // toast()
      //   .success("", "Email Send Sucessfully")
      //   .with({
      //     shape: "pill",
      //     duration: 4000,
      //     speed: 1000,
      //     positionX: "end",
      //     positionY: "top",
      //     color: "bg-primary",
      //     fontColor: "blue",
      //     fontTone: 200,
      //   })
      //   .show();
      ClearValues();
   
      });
  };

  const SendEmail = (ID) => {
    useGet('/api/email/SendsubmitqueryEmail?ID=' + ID)
        .then(res => {
            toast().success('', 'Email Send Sucessfully').with({
                shape: 'square',
                duration: 2000,
                speed: 200,
                positionX: 'end',
                positionY: 'top',
                color: 'text-white bg-primary border-primary-dark border rounded-lg',
                fontColor: 'white',
                fontTone: 0
            }).show()

            const timer = setTimeout(() => setQueryFormSubmmited(false), 5000)  //this will added later 
            if (cookie.getItem("queryFormSubmmited") == undefined) {
                setQueryFormSubmmited(false)
            } else {
                setQueryFormSubmmited(true)
            }
        });
}
 
  useEffect(() => { 
    localStorage.setItem("tempqueryarray", JSON.stringify(tempqueryarray))
  }, [tempqueryarray]);

  return (
    <DashboardLayout hideAccountDropdown={true}>
      <DashboardHeader  title="Connect with us">
        <NavLink
          to="/connect/contact-us/"
          className="mx-3 xl:mx-8"
          activeClassName="font-bold text-primary"
        >
          Contact Us
        </NavLink>
        <NavLink
          to="/connect/feedback/"
          className="mx-3 xl:mx-8"
          activeClassName="font-bold text-primary"
        >
          Feedback
        </NavLink>
        <NavLink
          to="/connect/participate-in-workshop/"
          className="mx-3 xl:mx-8"
          activeClassName="font-bold text-primary"
        >
          Participate in Workshop
        </NavLink>

      </DashboardHeader>
      <div className="mt-12">
        <h2 className="text-xle font-bold mb-1">Let us know how can we help</h2>
        <p>Select one or multiple answers that apply</p>
        <div
          className="flex items-center flex-wrap mt-4"
          style={{ maxWidth: 700 }}
        >
          {queryListJson &&
            queryListJson.length > 0 &&
            queryListJson.map((item, index, array) => {
              return (
                <Checkbox
                  label={item.label}
                  value={item.value}
                  name={item.name}
                  checked={item.checked}
                  onClick={(e) => onCheckBoxClick(item, index, array)}
                />
              );
            })}
        </div>
        <div className="mt-3">
          <Textarea
            id="message"
            onChange={handleChange}
            onBlur={handleBlur}
            label="Additional Message:"
            placeholder="Provide your feedback here"
          />
        </div>
        {/* <div className="my-2">
                    <Fileinput label="Add attachment" placeholder="Provide your feedback here" />
                </div> */}
        {isSucess && <div className="bg-primary text-white border-bg-primary-light rounded-md border px-8 py-4 inline-flex">
          Message has been successfully sent
        </div>}
        <div className="mt-6">
          {!isSending && ( <Button
            btnStyle="primary"
            processing={isSending}
            text="Send"
            extraClasses="px-20"
            onClick={() => SubmitQuery()}
          />) }
          {isSending && ( <Button
            btnStyle="primary"
            processing={isSending}
            extraClasses="px-20"
          />) }
        </div>
      </div>

      <EsriFooter />
    </DashboardLayout>
  );
};

export default ContactUs;
